/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  createComparableSearchQuery helpers
 */

import { getAPIFriendlyFilters } from '@zcode-ui/filters'
import { ON_BROWSER } from '@zcode/nr-utils'

export interface CreateComparableSearchQueryProps {
  filters: any
}

export const createComparableSearchQuery = ({ filters = {} }: CreateComparableSearchQueryProps) => {
  const query = filters

  if (filters) {
    delete query.bubbleId
    delete query.limit
    delete query.featuredLimit
    delete query.matching
    delete query.offset
    delete query.sort
  }

  if (ON_BROWSER) {
    query.originUrl = window.location.pathname
  }

  // if user has more than 300 disliked listing w/ 5 alerts, Entity too large happens
  delete query.buildingIds
  delete query.listingIds

  const comparableFilters = getAPIFriendlyFilters({
    filters: query,
  })

  delete comparableFilters?.maxLat
  delete comparableFilters?.maxLng
  delete comparableFilters?.minLat
  delete comparableFilters?.minLng

  return comparableFilters
}
